import { produce } from 'immer';
import type { StoreApi } from 'zustand/vanilla';
import type { DeviceDetailsType, GlobalAppStateStore } from '../types';

export type DeviceVariantActionProps = {
  operation: 'SWITCH_DEVICE';
  payload: {
    deviceDetails: DeviceDetailsType;
  };
};

const getDeviceVariantActions =
  (set: StoreApi<GlobalAppStateStore>['setState']) =>
  ({ operation, payload }: DeviceVariantActionProps) => {
    switch (operation) {
      case 'SWITCH_DEVICE': {
        set((state) =>
          produce(state, (draft) => {
            draft.deviceDetails = payload.deviceDetails;
          }),
        );
      }
    }
  };

export default getDeviceVariantActions;
